import {
  EnvironmentInjector,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  runInInjectionContext,
} from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/compat/firestore';

/**
 * AngularFire 19+ compat classes call inject() when they are constructed, so
 * collection()/doc() throw NG0203 when called lazily (e.g. inside an Observable).
 * AngularFirestore is providedIn 'any', so lazy routes get their own instances;
 * patching the prototypes covers every instance, not just the root one.
 */
const REF_FACTORIES: [{ prototype: object }, string[]][] = [
  [AngularFirestore, ['collection', 'collectionGroup', 'doc']],
  [AngularFirestoreCollection, ['doc']],
  [AngularFirestoreDocument, ['collection']],
];

let appInjector: EnvironmentInjector;
let patched = false;

function patchRefFactories(): void {
  for (const [type, methods] of REF_FACTORIES) {
    const proto = type.prototype as Record<string, (...args: unknown[]) => unknown>;
    for (const method of methods) {
      const original = proto[method];
      proto[method] = function (this: unknown, ...args: unknown[]) {
        return runInInjectionContext(appInjector, () => original.apply(this, args));
      };
    }
  }
}

export function provideInjectionContextAngularFirestore(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    appInjector = inject(EnvironmentInjector);
    if (!patched) {
      patchRefFactories();
      patched = true;
    }
  });
}
